import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const SidebarPaddedContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  padding: 0.5rem 1.5rem 1rem 1.5rem;
`;
